export { FileDirectoryBucket } from './generated/FileDirectoryBucket.js';